// features/userMeta/userMetaSlice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { decryptData } from '../../helpers/functions/functions';
import { createCardWithLink, createEmployeeCard } from '../cards/cardThunks';


// Define the shape of user state
interface UserMetaState {
  data: any | null;
  loading: boolean;
  isUserMetaExists: boolean;
  error: string | null;
}

const initialState: UserMetaState = {
  data: null,
  loading: false,
  isUserMetaExists: false,
  error: null
};

export const fetchUserMeta = createAsyncThunk(
  'userMeta/fetchUserMeta',
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem('viart_token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const decrypted = decryptData(response.data.enc);
      return decrypted;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || 'Failed to load user meta');
    }
  }
);

const userMetaSlice = createSlice({
  name: 'userMeta',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUserMeta.pending, state => {
        state.loading = true;
        state.error = null;
        state.isUserMetaExists = false;
      })
      .addCase(fetchUserMeta.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isUserMetaExists = true;
      })
      .addCase(fetchUserMeta.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.isUserMetaExists = false;
        localStorage.removeItem('viart_token');
        localStorage.removeItem('viart_user');
      })

      // Keep counts in sync after card creation (server is the source of truth)
      .addCase(createCardWithLink.fulfilled, (state, action) => {
        if (state.data) {
          state.data.cardCount = action.payload.cardCount;
          state.data.employeeCount = action.payload.employeeCount;
        }
      })
      .addCase(createEmployeeCard.fulfilled, (state, action) => {
        if (state.data) {
          state.data.cardCount = action.payload.cardCount;
          state.data.employeeCount = action.payload.employeeCount;
        }
      });
  },
});

export default userMetaSlice.reducer;
